import { call, put } from 'redux-saga/effects';
import { takeEvery } from 'redux-saga';
import config from '../../config';
import request from 'superagent';

export function* getAffiliates() {
    yield* takeEvery("AFFILIATES/FETCH", function* (action) {
        try {
            const result = yield call(({ id }) => {
                return request.get(`${config.apiEndpoint}/api/cs/v2/affiliates${id ? `/${id}` : ''}`)
                    .set('Authorization', `Bearer ${config.apiKey}`)
                    .then(data => (JSON.parse(data.text)));
            }, action);

            if (result && result.success) {
                const { affiliates, affiliate } = result;
                if (action.id) {
                    yield put({ type: 'AFFILIATE/SET', affiliate });
                } else {
                    yield put({ type: 'AFFILIATES/SET', affiliates });
                }
            } else {
                yield put({
                    type: 'AFFILIATES/FETCH_FAILED',
                    result
                });
            }
        } catch (e) {
            yield put({
                type: 'AFFILIATES/FETCH_FAILED',
                e
            });
        }
    });
}


// WEBPACK FOOTER //
// ./src/redux-sagas/sagas/affiliates.js